import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, ref, watch } from 'vue';
import { useClickaway } from "../composables/clickaway";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppDropdown',
    props: {
        buttonStyle: {},
        position: {},
        remainOnSelect: { type: Boolean },
        open: { type: Boolean }
    },
    emits: [
        'select',
        'open',
        'close'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const props = __props;
        const theButtonStyle = computed(() => {
            return props.buttonStyle || 'default';
        });
        const showDropdown = ref(false);
        const el = ref(null);
        useClickaway(el, hideDropdown);
        watch(() => props.open, onOpenChange);
        onOpenChange();
        function toggleDrown() {
            showDropdown.value = !showDropdown.value;
            onDropdownStateChange();
        }
        function hideDropdown() {
            if (!showDropdown.value) {
                return;
            }
            showDropdown.value = false;
            onDropdownStateChange();
        }
        function onOpenChange() {
            showDropdown.value = props.open ?? false;
            onDropdownStateChange();
        }
        function selectItem(item, params) {
            emit('select', item, params);
            !props.remainOnSelect && hideDropdown();
        }
        function onDropdownStateChange() {
            if (showDropdown.value) {
                emit('open');
            }
            else {
                emit('close');
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["dropdown", { 'dropdown--open': showDropdown.value }]),
                ref_key: "el",
                ref: el
            }, [
                _createElementVNode("div", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (toggleDrown())),
                    class: _normalizeClass(["button", 'button--' + theButtonStyle.value])
                }, [
                    _renderSlot(_ctx.$slots, "button", {}, () => [
                        _cache[1] || (_cache[1] = _createTextVNode("\n                [button]\n            ", -1))
                    ])
                ], 2),
                _cache[5] || (_cache[5] = _createTextVNode()),
                _createElementVNode("menu", {
                    class: _normalizeClass(["dropdown__menu", { 'dropdown__menu--left': __props.position === 'left' }])
                }, [
                    _renderSlot(_ctx.$slots, "menu", { select: selectItem }, () => [
                        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "dropdown__item" }, "[item 1]", -1)),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "dropdown__item" }, "[item 2]", -1))
                    ])
                ], 2)
            ], 2));
        };
    }
});
